import React from 'react';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1>הטעם של האלפים, אצלך בבית</h1>
        <p>פולי קפה איכותיים 100% ערביקה, בקלייה איטית מסורתית – ישירות אליך</p>
        <a href="#products" className="hero-cta">גלו את הקולקציה</a>
      </div>
    </section>
  );
}
